$(function() {
    $(document).on('focus', 'input', function(){
        $(this).removeClass('u-error');
        $(this).closest('.js-container').find('.js-message').empty().removeClass('u-error');
        $(this).closest('label').removeClass('u-error');
    });
});
